var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 认证规则查询 "),_c('div',{on:{"click":_vm.handleDetail}},[_vm._v("点击详情")])])
}
var staticRenderFns = []

export { render, staticRenderFns }